import {Component, OnInit} from '@angular/core';
import {Global} from "../../global";
import {Components} from "../../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../../funcoes";
import {FichasModel} from "../../fichas/fichas.model";
import {ClientesFichasService} from "../clientes-fichas.service";
import {Form, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {BasicValidators} from "../../shared/basic-validators";
import {observable} from "rxjs/symbol/observable";
import {LoginService} from "../../login/login.service";

declare let swal, $: any;

@Component({
  selector: 'app-minhas-fichas',
  templateUrl: './minhas-fichas.component.html'
})
export class MinhasFichasComponent extends Components implements OnInit {

  fichas: FichasModel[] = [];
  formSolicitarFicha: FormGroup;
  formPesquisaAvancada: FormGroup;
  solicitaFicha = {"id_ficha": null, "nome": "", "email": ""};
  filtroPesquisa = {"de":"", "ate":"", "fatura":"", "conhecimento":"", "referencia":"", "container":""};
  processandoSolicitarFicha: boolean = false;
  listVisibilidades: any[] = [];
  clienteSelecionado: string = null;

  mascaraContainer = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  constructor(
    formBuilder: FormBuilder,
    private clientesFichasService: ClientesFichasService,
    private loginService: LoginService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes
  ) {
    super();

    this.formPesquisaAvancada = formBuilder.group({
      de: [],
      ate: [],
      fatura: [],
      conhecimento: [],
      referencia: [],
      container: []
    });

    this.formSolicitarFicha = formBuilder.group({
      id_ficha: ['', [
        Validators.required
      ]],
      nome: ['', [
        Validators.required
      ]],
      email: ['', [
        Validators.required,
        BasicValidators.email
      ]],
    });
  }

  ngOnInit() {
    this.clientesFichasService.getVisibilidades().subscribe(
      json => {
        if (json && json.Success && json.Payload) {
          this.listVisibilidades = json.Payload;
        }
      },
      error => {
        console.error('Erro ao carregar visibilidades:', error);
      }
    );
    this.getPage(1);
  }

  selecionarAbaCliente(idCliente: string = null) {
    this.clienteSelecionado = idCliente;
    this.getPage(1);
  }

  formatNomeAba(nome: string): string {
    if (!nome) return '';
    return nome.length > 40 ? nome.substring(0, 40) + '...' : nome;
  }

  getNomeTratamento(entidade: any): string {
    if (!entidade) return '';
    return entidade.nome_tratamento || entidade.nome || '';
  }

  formatNome(texto: string, limite: number = 25): string {
    if (!texto) return '';
    return texto.length > limite ? texto.substring(0, limite) + '...' : texto;
  }

  getPage(pagina){

    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if (this.clienteSelecionado) {
      filtros['id_cliente'] = "eq:" + this.clienteSelecionado;
    }

    if(this.filtroPesquisa.de != ''){
      filtros['de'] = "**:"+this.filtroPesquisa.de;
    }

    if(this.filtroPesquisa.ate != ''){
      filtros['ate'] = "**:"+this.filtroPesquisa.ate;
    }

    if(this.filtroPesquisa.fatura != ''){
      filtros['fatura'] = "**:"+this.filtroPesquisa.fatura;
    }

    if(this.filtroPesquisa.conhecimento != ''){
      filtros['conhecimento'] = "**:"+this.filtroPesquisa.conhecimento;
    }

    if(this.filtroPesquisa.referencia != ''){
      filtros['referencia'] = "**:"+this.filtroPesquisa.referencia;
    }

    if(this.filtroPesquisa.container != ''){
      filtros['container'] = "**:"+this.filtroPesquisa.container;
    }

    this.clientesFichasService.getPaginacao(pagina,this.itensPorPagina, ["importador","exportador","mercadoria"], filtros)
      .subscribe(data => {
        this.fichas = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  loadTooltip(){
    setTimeout(function(){
      $('[data-popup="tooltip"]').tooltip();
    }, 1000);

  }

  modalPesquisaAvancada(){
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada(){
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada(){
    this.filtroPesquisa = {"de":"", "ate":"", "fatura":"", "conhecimento":"", "referencia":"", "container":""};
  }

  // evento quando o container é alterado
  changeContainer(e){
    this.filtroPesquisa.container = e.toUpperCase().replace(/_/g, '');
  }

  modalSolicitaFicha(id){
    this.solicitaFicha.id_ficha = id;
    this.processandoSolicitarFicha = false;
    $('#modalSolicitarFicha').modal('show');
  }

  solicitaFichaEmail(){
    this.processandoSolicitarFicha = true;
    this.clientesFichasService.enviaPdfEmail(this.solicitaFicha.id_ficha, this.solicitaFicha)
      .subscribe(json => {
          this.processandoSolicitarFicha = false;
          $('#modalSolicitarFicha').modal('hide');
        },
        error => {
          this.processandoSolicitarFicha = false;
          this.func.showErro(error.json());
        });
  }

  baixarPdf(id) {
    this.carregandoTabela = true;
    this.clientesFichasService.baixarZipPdf(id)
      .subscribe(
        json => {
          this.carregandoTabela = false;
          if (json && json.Success && json.Payload) {
            window.open(this.clientesFichasService.dominio + json.Payload, '_blank');
          } else {
            swal("Erro", "Erro ao baixar PDF.", "error");
          }
        },
        error => {
          this.carregandoTabela = false;
          this.func.showErro(error.json());
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/area-cliente/minhas-fichas/minhas-fichas.component.ts